import React from 'react';
import { AppRouter } from 'Components/Router';
import GlobalStyles from 'Components/GlobalStyles';
function App() {
  return (
    <>
      <AppRouter />
      <GlobalStyles />
    </>
  );
}

export default App;
